import {getPlayRank, createPlayRank, updatePlayRank} from "api-v3";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {GAME_STATE} from "utils";
import View from "./View";

export default function Container() {
  const {gameState} = useSelector(state => state.game);
  const {id} = useSelector(state => state.userinfo);

  useEffect(() => {
    if (gameState === GAME_STATE.ENDED) {
      const joystick = document.querySelector("#joystick");
      const jumpButton = document.querySelector("#joystick_button_J");

      if (joystick) {
        joystick.remove();
      }

      if (jumpButton) {
        jumpButton.remove();
      }
    }
  }, [gameState]);

  const getKSTDateString = () => {
    const date = new Date();

    date.setTime(date.getTime() + 9 * 60 * 60 * 1000);

    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const day = date.getUTCDate().toString().padStart(2, "0");
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return <View gameState={gameState} />;
}
